<template>
    <div class="main">
        <div id="Nav" class="left">
            <div class="back"><button @click="back()" class="button icon fastic-circle-left" :aria-label="localizer.get('App.Common.PageBack')"></button></div>
            <div class="content">
                <h1 class="maintitle s60">{{ localizer.get("Account.PasswordRemind.Title") }}</h1>
                <div class="desc">{{ localizer.get("Account.PasswordRemind.Desc") }}</div>
            </div>
            <app-footer></app-footer>
        </div>
        <main id="Main" class="right">
            <div class="logo" data-color="cyan50">
                <a :href="routes.Home"><img src="/images/logo.svg" width="125" height="35" :alt="localizer.get('App.Common.Beghelli')" /></a>
            </div>
            <div @keydown.enter.prevent.stop="submitForm()" class="content">
                <div class="intro">
                    <h2 class="maintitle s36">{{ localizer.get("Account.PasswordRemind.ResetPassword") }}</h2>
                </div>
                <div ref="form" class="form">
                    <fieldset>
                        <div class="item">
                            <label for="Email">{{ localizer.get("App.Form.Email") }}</label>
                            <input type="email" id="Email" :placeholder="localizer.get('App.Form.EmailPlaceholder')" v-model.lazy="formData.email" :class="[{ 'input-validation-error': formHelper.isControlValidationError('Email', validationErrors) }, 'input w300']" />
                        </div>
                    </fieldset>
                    <fieldset>
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="cta"><button :class="[{ 'loading': isLoading }, 'button']" @click="submitForm()"><template v-if="!isLoading">{{ localizer.get("Account.PasswordRemind.ResetPassword") }}</template></button></div>
                    </fieldset>
                    <div class="desc small grecaptcha-terms" v-html="localizer.get('App.Support.Captcha_Terms')"></div>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{ recaptchaSiteKey: string }>();

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

function back() {
    window.history.back();
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;
    
    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });
        try {
            let result = (await Axios.post(routes.Account_User_PasswordRemind, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": token } })).data;
            isSuccess.value = true;
            window.location.href = result.redirectUrl;
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
        isLoading.value = false;
    });
}
</script>